var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mku-button-wrapper", style: _vm.buttonWrapperStyle },
    [
      _c(
        "button",
        {
          class: [
            "mku-button",
            {
              "mku-button--primary": _vm.type === "primary",
              "mku-button--dashed": _vm.type === "dashed",
              "mku-button--default": _vm.type === "default",
              "mku-button--danger": _vm.type === "danger",
              "mku-button--link": _vm.type === "link",
              "mku-button--lg": _vm.size === "large",
              "mku-button--sm": _vm.size === "small",
              "mku-button--loading": _vm.loading
            }
          ],
          attrs: { disabled: _vm.disabled },
          on: { click: _vm.handleClick }
        },
        [
          _vm.icon || _vm.loading
            ? _c("mku-icon", { attrs: { type: _vm.buttonIcon } })
            : _vm._e(),
          _vm._v(" "),
          _vm._t("default")
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }